export type ValidationMessages = typeof validationMessages;

/** Object with frontend validation error messages */
export const validationMessages = {
  required: 'Required field',
  requiredFile: 'Please upload a file',
  invalidNumber: 'Value must be a number',
  negativeNumberNotAllowed: 'Value cannot be negative',
  invalidEmail: 'Please enter a valid email address',
  invalidCredentials: 'Please enter a valid credentials',
  passwordsDoNotMatch: 'Passwords do not match',
  minLength: (len: number) => `Minimum length is ${len} characters`,
  maxLength: (len: number) => `Maximum length is ${len} characters`,
};
